import { StandardBody } from './StandardBody'

export default StandardBody
